import APIAmplify from '@/amplify/api';

import Constant from '@/common/constant/Constant';

import { hasKnowledgeChatPermissionInChatThread } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import { onTicketUpdated } from '@/graphql/subscriptions';

const SUBSCRIPTION_TYPE = Constant.SUBSCRIPTION_TYPE;

// list all subscription for ticket
let subscriptionTicketList = [];

/**
 * Find index subscription ticket list
 * @param {*} typeSubscription
 * @param {*} panelId
 * @param {*} argsCommon
 * @returns index
 */
const findIndexSubcriptionTicketList = (typeSubscription, panelId, argsCommon) => {
    let index = subscriptionTicketList.findIndex((sub, i) => {
        return sub.type === typeSubscription && sub.panelId === panelId;
    });
    return index === undefined || index === null ? -1 : index;
};

/**
 * Unsubscribe all with: event update
 */
export const unsubscribeEventTicket = (typeSubscription, panelId, argsCommon) => {
    let isUnsubscribeEventTicket = false;
    // find index of subscription
    let index = findIndexSubcriptionTicketList(typeSubscription, panelId, argsCommon);
    if (index < 0) {
        return isUnsubscribeEventTicket;
    }

    // unsubscribe event
    if (subscriptionTicketList[index].subscription?._state !== 'closed') {
        subscriptionTicketList[index].subscription?.unsubscribe();
        isUnsubscribeEventTicket = true;
    }
    // remove item in subcription list
    subscriptionTicketList.splice(index, 1);

    return isUnsubscribeEventTicket;
};

/**
 * Update ticket list state
 * @param {*} ticket
 * @param {*} argsCommon
 */
const updateTicketListState = (ticket, argsCommon) => {
    switch (argsCommon.ticketListTab) {
        case Constant.LIST_TICKET_TAB.INTERNAL_QA:
        case Constant.LIST_TICKET_TAB.CUSTOM_SUPPORT:
            argsCommon.setUpdatedTicket(ticket);
            break;
        default:
            // todo
            break;
    }
};

/**
 * Listen subscription event update ticket
 * @param {*} API
 * @param {*} argsCommon
 */
export const onSubscriptionEventUpdateTicket = (API, argsCommon) => {
    // check empty and exists of list
    // if subscriptionNotificationList exists then break;
    let index = findIndexSubcriptionTicketList(
        SUBSCRIPTION_TYPE.UPDATE,
        argsCommon.panelId,
        argsCommon
    );
    if (index !== -1) {
        return;
    }

    let subscription = APIAmplify.graphql({
        query: onTicketUpdated
    }).subscribe({
        next: resData => {
            let msgRes = resData.value.data.onTicketUpdated;
            // update notification list
            updateTicketListState(msgRes, argsCommon);
            // check show msgcommon30 if no chat permission
            if (
                msgRes?.id === argsCommon?.ticketDetailSelected?.id &&
                argsCommon?.isChartThreadSubscription
            ) {
                const isShowReload = !hasKnowledgeChatPermissionInChatThread(
                    msgRes,
                    argsCommon.projectInuseDetail,
                    argsCommon.userDetail?.id,
                    false,
                    argsCommon.currentProjectB2BCustomerIdList,
                    argsCommon.currentProjectB2BHelpdeskIdList
                );
                if (isShowReload) argsCommon.setIsOpenModalReloadPage(isShowReload);
            }
        },
        error: err => {
            // unsubscription event update
            let isUnsubscribeEventTicket = unsubscribeEventTicket(
                SUBSCRIPTION_TYPE.UPDATE,
                argsCommon.panelId,
                argsCommon
            );

            // show alert disconnect
            // if isShowDialog equals true then break
            if (!argsCommon.isShowReconnectDialog && isUnsubscribeEventTicket === true) {
                argsCommon.setIsShowReconnectDialog(true);
            }
        }
    });
    // push subscription to list
    subscriptionTicketList.push({
        type: SUBSCRIPTION_TYPE.UPDATE,
        panelId: argsCommon.panelId,
        subscription: subscription
    });
};

/**
 * Init subscription ticket
 * 1: Event update
 * 2: Event create
 * 3: Event delete
 * @param {*} args
 */
export const initSubscriptionTicket = argsCommon => {
    onSubscriptionEventUpdateTicket(argsCommon.API, argsCommon);
};
